import * as React from 'react';
import { ArrowsSort } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { Icon } from '../../Icon/src/Icon.js';
import modules_a2a4272b from '../styles/Sorter.module.less.js';

const Sorter = (props) => {
    const { isSorted, ...restProps } = props;
    const cx = useStyles(modules_a2a4272b);
    if (!isSorted) {
        return (React.createElement("div", { className: cx('container'), ...restProps },
            React.createElement(Icon, { className: cx('icon-sort'), icon: React.createElement(ArrowsSort, null) })));
    }
    if (isSorted === 'asc') {
        return (React.createElement("div", { className: cx('container'), ...restProps },
            React.createElement(Icon, { className: cx('icon-sort', 'fill', 'sort-asc'), icon: React.createElement(ArrowsSort, null) }),
            React.createElement(Icon, { className: cx('icon-sort'), icon: React.createElement(ArrowsSort, null) })));
    }
    return (React.createElement("div", { className: cx('container'), ...restProps },
        React.createElement(Icon, { className: cx('icon-sort', 'fill', 'sort-asc', 'sort-desc'), icon: React.createElement(ArrowsSort, null) }),
        React.createElement(Icon, { className: cx('icon-sort'), icon: React.createElement(ArrowsSort, null) })));
};

export { Sorter };
//# sourceMappingURL=Sorter.js.map
